import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import Loader from "../../control-components/loader/loader";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";
import APP_ROUTES from "../../helper/app-routes";
import { AnnouncementServices } from "../../services/announcementService";
import {Customeditor} from "../../control-components/custom-editor/custom-editor";
import { Error } from "@progress/kendo-react-labels";
import moment from "moment";

const ADDBaa = ({}) => {
  const navigate = useNavigate();
  const location  = useLocation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [settingError, setSettingError] = useState(false);
  const staffId = useSelector((state) => state.loggedIn?.staffId);
  const state  = location && location.state;
  const isEdit = location && state && state.isEdit
  const isDuplicate = location && state && state.isDuplicate

  const [fields, setFields] = useState({
    body: "",
    dateStart: new Date(),
    dateEnd: new Date(),
  });

  useEffect(() => {
    if(state && state.baa) {
        setFields((prev) => ({
            ...prev,
            dateStart: state.baa.announcementDate
                ? new Date(state.baa.announcementDate)
                : null,
            dateEnd: state.baa.enforcementDate
                ? new Date(state.baa.enforcementDate)
                : null,
            body: state.baa.body
        }))
    }
  }, [state])

  const handleSubmit = async () => {
    setSettingError(true);
    
    if (!handleValidation()) {
      return;
    }
    const submissionData = {
      body: fields.body.trim(),
      announcementDate: moment(fields.dateStart).format("M/D/YYYY"),
      enforcementDate: moment(fields.dateEnd).format("M/D/YYYY")
    };

    try {
      setLoading(true);
      
      if (isEdit) {
        const data = {
            "versionNo": state?.baa?.versionNo,
            "announcementDate": moment(fields.dateStart).format("M/D/YYYY"),
            "enforcementDate": moment(fields.dateEnd).format("M/D/YYYY"),
            "updatedBy": staffId
        }
        await AnnouncementServices.update_Baa(data);
        NotificationManager.success("BAA updated successfully");
      } 
      else {

        await AnnouncementServices.add_Baa(submissionData);
        NotificationManager.success("BAA created successfully");
       
      }
      
      handleCancel();
    } catch (error) {
      NotificationManager.error(error.message || "Error processing BAA");
      setLoading(false);
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.body.trim()) {
      formIsValid = false;
      errors.body = "Agreement is required";
    }

    if (!fields.dateStart) {
      formIsValid = false;
      errors.dateStart = "Announcement date is required";
    }

    if (!fields.dateEnd) {
      formIsValid = false;
      errors.dateEnd = "Enforcement date is required";
    }



    if (
      fields.dateStart &&
      fields.dateEnd &&
      moment(fields.dateEnd).isBefore(moment(fields.dateStart))
    ) {
      formIsValid = false;
      errors.dateEndLessThanStart = "Enforcement date must be after or equal to announcement date";
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleCancel = () => {
    if(isDuplicate) {
      navigate(APP_ROUTES.HISTORY_BAA);
    }
    else if(isEdit) {
      navigate(APP_ROUTES.BAA);
    }
    else {
      navigate(APP_ROUTES.BAA);
    }
  };

  const handleTextChange = (props) => {
    const sanitizeContent = (html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html.trim();
      const elementsWithAttributes = tempDiv.querySelectorAll("*");
      elementsWithAttributes.forEach((el) => {
        el.removeAttribute("style");
        el.removeAttribute("class");
      });
 
      return tempDiv.textContent?.trim() === "" ? "" : tempDiv.innerHTML;
    };
 
    const cleanedContent = sanitizeContent(props.html);
 
    setFields({
      ...fields,
      body: cleanedContent,
    });
 
  };


  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (e.target && e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    if (e.target.props && e.target.props.textField) {
      value = { 
        id: e.target.value.id,
        [e.target.props.textField]: e.target.value[e.target.props.textField]
      };
    }

    setFields(prevFields => ({
      ...prevFields,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };



  return (
    <>
      <div className="client-accept notenetic-container">
        <div className="row">
          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              onChange={handleChange}
              value={fields.dateStart}
              name="dateStart"
              label="Announcement Date"
              error={errors.dateStart}
              required={true}
              validityStyles={settingError}
              min={new Date()}
            />
          </div>

          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              onChange={handleChange}
              value={fields.dateEnd}
              name="dateEnd"
              label="Enforcement Date"
              required={true}
              validityStyles={settingError}
              min={new Date()}
            />
            <Error>{errors.dateEnd || errors.dateEndLessThanStart}</Error>
          </div>

          <div className="mb-3 col-lg-12 col-md-12 col-12">
                {(isEdit) ? (
                    <div dangerouslySetInnerHTML={{ __html: fields.body ?? '' }} />
                ) : (
                    <>
                    <Customeditor
                        value={fields.body}
                        onChange={handleTextChange}
                        height={300}
                        label="Agreement"
                        disabled
                    />
                    <Error>{errors.body}</Error>
                    </>
                )}
            </div>

        </div>
      </div>

      {loading && <Loader />}

      <div className="d-flex my-4">
        <button 
          className="green-btn btn-primary mr-3 btn-space" 
          onClick={handleSubmit}
        >
          {(state && isEdit) ? "Update" : "Add"}
        </button>
        <button 
          className="btn grey-secondary btn-space" 
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export default ADDBaa;;